/**
 * @typedef {Object} TreeViewDtoType
 * @property {number} id - Unique identifier
 * @property {string} name
 * @property {boolean} locked - Disables node and children
 * @property {TreeViewDtoType[]} children
 */

/**
 * @class
 */
export default class TreeViewDto {
  /**
   * Create a new TreeViewDto.
   * @param {...TreeViewDtoType} params
   */
  constructor(params) {
    this.id = params.id
    this.name = params.name
    this.locked = params.locked
    this.children = params.children ?? []
  }
}
